import { render, staticRenderFns } from "./ChecklistSettings.vue?vue&type=template&id=613d62b5"
import script from "./ChecklistSettings.vue?vue&type=script&lang=js"
export * from "./ChecklistSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports